module.exports = __webpack_public_path__ + "static/media/vibepure-5.c233247f.jpg";